import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Button from '../../../components/Button';
import { Checkbox } from 'semantic-ui-react';
import { EditIcon } from '../../../components/icons';
import TextField from '../../OrderEntry/ui/TextField';
import Select from 'react-select';
import NewUserModal from './NewUserModal';
import axios from 'axios';
import { DropdownOption, ClientUser } from '../types';
import produce from 'immer';

const SaveStyles = styled.div`
  position: absolute;
  right: 55px;
  top: 35px;
  background-color: #444340;
  border-radius: 5px;
  padding: 8px 16px;
  color: #fff;
  cursor: pointer;
`;

const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    width: 175,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #f5f5f5',
    height: 48,
  }),
};

const multiSelectStyles = {
  valueContainer: (provided: any) => ({
    ...provided,
    maxHeight: '200px',
    overflow: 'auto',
    minHeight: 45,
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided,
    borderRadius: '15px',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  }),
};

interface IProps {
  clientuser: ClientUser;
  roles: DropdownOption[];
  notificationTypes?: DropdownOption[];
  afterSavingCall: () => void;
  singleAdmin: boolean;
}

export default function EditRow(props: IProps) {
  const [editUser, setEditUser] = useState(props.clientuser);
  const [updatingChanges, setUpdatingChanges] = useState(false);
  const [singleAdminAlert, setSingleAdminAlert] = useState(false);
  const changeUserInfo = (label: keyof Partial<ClientUser>, value: any) => {
    const newUser = produce(editUser, draft => {
      (draft[label] as any) = value;
      if (label === 'contactNotificationTypes') {
        draft.editedNotificationTypes = true;
      } else if (props.singleAdmin && label === 'roleOption' && value.label === 'Member') {
        setSingleAdminAlert(true);
      } else {
        setSingleAdminAlert(false);
      }
    });
    setEditUser(newUser);
  };

  const onSaveChanges = async () => {
    if (singleAdminAlert) {
      return;
    }
    setUpdatingChanges(true);
    await axios.post('/api/ClientProfile/UpdateClientContacts/', editUser);
    setUpdatingChanges(false);
    props.afterSavingCall();
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex' }}>
        <TextField
          name="firstName"
          label=""
          width="120"
          value={editUser.firstName}
          onChange={e => changeUserInfo('firstName', e.target.value)}
          styles={{ input: { paddingLeft: 8 }, marginRight: 8 }}
        />
        <TextField
          name="lastName"
          label=""
          width="120"
          value={editUser.lastName}
          onChange={e => changeUserInfo('lastName', e.target.value)}
          styles={{ input: { paddingLeft: 8 } }}
        />
      </div>

      <TextField
        name="email"
        label=""
        width="200"
        value={editUser.email}
        onChange={e => changeUserInfo('email', e.target.value)}
        styles={{ input: { paddingLeft: 8 } }}
      />
      <div style={{ position: 'relative' }}>
        {editUser.roleOption.value !== 0 ? (
          <Select
            options={props.roles}
            value={editUser.roleOption}
            onChange={e => {
              changeUserInfo('roleOption', e);
            }}
            styles={customStyles}
            placeholder={''}
            components={{
              IndicatorSeparator: null,
            }}
          />
        ) : (
          <div />
        )}
        {singleAdminAlert && (
          <div style={{ color: '#ff5252', position: 'absolute', top: 50, fontSize: 11, lineHeight: 1.2 }}>
            {' '}
            There must be at least one administrator on your account.
          </div>
        )}
      </div>
      <div>
        {/* <Select
        options={props.notificationTypes}
        value={editUser.contactNotificationTypes}
        onChange={e => changeUserInfo('contactNotificationTypes', e)}
        styles={multiSelectStyles}
        isMulti
        isClearable={false}
        placeholder={''}
        components={{
          IndicatorSeparator: null,
        }}
      /> */}
      </div>
      <SaveStyles onClick={onSaveChanges} style={{ cursor: singleAdminAlert ? 'not-allowed' : 'pointer' }}>
        {updatingChanges ? 'Saved' : 'Save'}
      </SaveStyles>
    </React.Fragment>
  );
}
